import React, { useEffect, useState } from 'react';
import Universalpageheader from '../Headers/universalpageheader';
import Productcard from '../Products/productcard';
import { Button, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Searchbar from '../Components/searchbar';
import constants from "./../Utils/constants.json"
import { removeFromStore } from '../Utils/fn';
import { setFavorites } from '../../store/favorites';
import Errorcomponent from '../Components/errorcomponent';


function Saveditems() {
    const dispatch = useDispatch();
    const subProducts = useSelector((state) => state.subProducts.data);
    const favorites = useSelector(state => state.favorites.data);

    const [loading, setloading] = useState(false);
    const [showsearchbar, setshowsearchbar] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function clearFavorites() {
        removeFromStore(constants.FAVORITES);
        dispatch(setFavorites([]));
    }


    return (
        <div className="homebody">
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={"Saved Items"} withbackicon={true} />
            {loading && <div className='mainloadingdiv'><CircularProgress /></div>}
            <div >
                <div className='wrapfourcards' style={{ height: "80%" }}>
                    {favorites?.map((val, key) => {
                        return (
                            <Productcard product={val} key={key} showoffer={true} />
                        )
                    })}
                </div>
                {favorites.length < 1 && <Errorcomponent error={"No saved items"} />}
                {favorites.length > 0 &&
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Button onClick={() => clearFavorites()}>CLEAR ALL</Button>
                    </div>
                }
            </div>
        </div>
    );
}


export default Saveditems;
